export enum UrlCommand {
  ReturnUri = 'return_uri',
}
